export const PrintSvg = ({ width = 18, height = 18 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7 8V3H17V8M7 17H5C3.89543 17 3 16.1046 3 15V10C3 8.89543 3.89543 8 5 8H19C20.1046 8 21 8.89543 21 10V15C21 16.1046 20.1046 17 19 17H17M7 14H17V21H7V14Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="17.5" cy="11.5" r="1" fill="currentColor" />
  </svg>
);
